import React from "react";
import { useDispatch } from "react-redux";
import {
  SideNav as SideNavStyle,
  SideNavCenter,
  HeaderContainer,
} from "./style";
import SideNavItem from "./Items";
import PngLogo from "../../../assets/images/png/luaa_logo.png";
import { FaRegEdit } from "react-icons/fa";
import ModalTypesEnum from "../../../utils/mapper/enums/ModalTypesEnum";
import { showModal } from "../../../actions/modal.action";

export default function MessageSideNav({
  users,
  handleItemClick,
  activeUserMatricNumber,
  loading,
}) {
  const dispatch = useDispatch();
  const chatRoom = {
    id: "af7c1fe6-d669-414e-b066-e9733f0de7a8",
    fullName: "Chat Room",
    matricNumber: "CHATROOM",
    profileImage: PngLogo,
    message: "Chatroom",
  };

  const handleModal = () => {
    const payload = {};
    dispatch(showModal(ModalTypesEnum.CHAT_USER_FETCH_REQUEST, payload));
  };
  return (
    <SideNavStyle>
      <HeaderContainer>
        <div>Messages</div>
        <div>
          <FaRegEdit
            size={25}
            onClick={() => handleModal()}
            className="cursor-pointer"
          />
        </div>
      </HeaderContainer>
      <SideNavCenter>
        <SideNavItem
          icon={chatRoom.profileImage}
          name={chatRoom.fullName}
          message={chatRoom.message}
          onClick={() => handleItemClick(chatRoom)}
        />
        {loading ? (
          "Loading..."
        ) : (
          <>
            {users.map((item, index) => {
              if (activeUserMatricNumber !== item.matricNumber) {
                return (
                  <SideNavItem
                    key={index}
                    icon={
                      item.profileImage === null ? PngLogo : item.profileImage
                    }
                    name={item.fullName}
                    message={item.lastMessage}
                    newMessageCount={item.newMessageCount}
                    onClick={() => handleItemClick(item, index)}
                  />
                );
              }
            })}
          </>
        )}
      </SideNavCenter>
    </SideNavStyle>
  );
}
